module.exports = __webpack_public_path__ + "img/cover-aygaz-conversion-club.04d77258.png";